/** @jsxImportSource @emotion/react */

import {
  css,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import BaseButton from "components/common/Button/Base";
import BaseInput from "components/common/Input/Base";
import { EMAIL_REG_EX } from "data/user.data";
import { sendTempPassword } from "pages/remotes";
import { useRef, useState } from "react";
import { PALETTE } from "styles/base/variables";

interface FindPasswordDialogProps {
  isOpen: boolean;
  setIsOpen: (value: boolean) => void;
}

function FindPasswordDialog({ isOpen, setIsOpen }: FindPasswordDialogProps) {
  const emailRef = useRef<HTMLInputElement>(null);
  const nameRef = useRef<HTMLInputElement>(null);

  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [errMsg, setErrMsg] = useState<string>("");

  const closeDialog = () => {
    setIsOpen(false);
    setIsLoading(false);
    setErrMsg("");
  };

  const checkUserNameMail = () => {
    if (!emailRef.current?.value) {
      setErrMsg("이메일을 입력해주세요.");
      return;
    }

    if (!emailRef.current.value.match(EMAIL_REG_EX)) {
      setErrMsg("올바른 이메일 주소를 입력해주세요.");
      return;
    }

    setIsLoading(true);
    sendTempPassword({
      email: emailRef.current.value,
    })
      .then((res) => {
        setIsLoading(false);
        window.alert("이메일로 임시 비밀번호를 발송하였습니다.");
        setTimeout(() => {
          closeDialog();
        }, 3000);
      })
      .catch((err) => {
        setIsLoading(false);
        setErrMsg(err.response.data.message);
      });
  };

  return (
    <Dialog open={isOpen} onClose={closeDialog}>
      <DialogTitle
        css={css`
          margin-bottom: 20px;
          background-color: ${PALETTE.background};
        `}
      >
        <h5>비밀번호 찾기</h5>
      </DialogTitle>
      <DialogContent
        css={css`
          display: flex;
          flex-direction: column;
          gap: 16px;
        `}
      >
        <BaseInput
          variant="outlined"
          type="email"
          placeholder="이메일"
          required
          ref={emailRef}
          css={css`
            width: 240px;
          `}
        />
      </DialogContent>
      <div
        css={css`
          height: 14px;
          margin: 0 24px;
          border-bottom: 1px solid ${PALETTE.border};
        `}
      >
        <p
          css={css`
            margin-top: -8px;
            font-size: 12px;
            color: ${PALETTE.error};
          `}
        >
          {errMsg && errMsg}
        </p>
      </div>
      <DialogActions
        css={css`
          padding: 16px 24px;
        `}
      >
        <BaseButton variant="outlined" onClick={closeDialog}>
          닫기
        </BaseButton>
        <BaseButton
          variant="contained"
          color={PALETTE.primary}
          disabled={isLoading}
          onClick={checkUserNameMail}
        >
          확인
        </BaseButton>
      </DialogActions>
    </Dialog>
  );
}

export default FindPasswordDialog;
